import React from "react";
import { FormGroup, InputText, Button } from "@accessdev/arc-ui-react";
import { useDispatch } from "react-redux";
import { Creators } from "@ReduxStore/actionTypes";
import { signUpSteps } from "../../authHelpers";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

function Name(props) {
  const inputRef = React.useRef(null);
  const dispatch = useDispatch();
  const onSubmit = (event) => {
    dispatch(Creators.setSignUpStep(signUpSteps.PASSWORD));
  };

  React.useEffect(() => {
    if (inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 200);
    }
  }, [inputRef]);

  return (
    <FormGroup onSubmit={onSubmit}>
      <div className="SignUp-form_names">
        <InputText
          ref={inputRef}
          type="text"
          label={t`First Name`}
          name="firstName"
          id="firstName"
          isRequired={true}
          onChange={props.onValueChange}
          value={props.values.firstName}
          requiredLabel=""
        />
        <InputText
          type="text"
          label={t`Last Name`}
          isRequired={true}
          name="lastName"
          id="lastName"
          onChange={props.onValueChange}
          value={props.values.lastName}
          requiredLabel=""
        />
      </div>
      <Button type="submit" className="SignUpWizard-nextSubmitBtn">
        <Trans>Next</Trans>
      </Button>
    </FormGroup>
  );
}

export default Name;
